<template>
  <div class="buyer-bank-addition">
    <banks-accordion
      v-if="showAccordion"
      :buyer="buyer"
      :bank-list="bankList"
      @selected-bank-index="(i) => $emit('selected-bank-index', i)"
      @fetch-bank-list="$emit('fetch-bank-list')"
      :selected-bank="selectedBank"
    />
    <new-buyer-bank
      :buyer="buyer"
      @fetch-bank-list="$emit('fetch-bank-list')"
    />
  </div>
</template>

<script>
import BanksAccordion from '@/components/invoices/Add/Forms/funding/BanksAccordion'
import NewBuyerBank from '@/components/invoices/Add/Forms/funding/NewBuyerBank'

export default {
  props: {
    bankList: {
      type: Array,
      required: false,
      default: () => []
    },
    showAccordion: {
      type: Boolean,
      required: false,
      default: false
    },
    buyer: {
      type: Object,
      required: false,
      default: () => ({})
    },
    selectedBank: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  components: {
    BanksAccordion,
    NewBuyerBank
  }
}
</script>
